import { Form, Input } from "antd";
import type React from "react";

const VitalSignsSection: React.FC = () => {
  return (
    <div className="flex flex-wrap w-full gap-4 form-row metrics-row">
      <div className="flex-1">
        <Form.Item label="Temperature(°C)" name="temperature" className="!mb-0">
          <Input className="form-input" />
        </Form.Item>
      </div>
      <div className="flex-1">
        <Form.Item label="Systolic(mmHg)" name="systolic" className="!mb-0">
          <Input className="form-input" />
        </Form.Item>
      </div>
      <div className="flex-1">
        <Form.Item label="Diastolic(mmHg)" name="diastolic" className="!mb-0">
          <Input className="form-input" />
        </Form.Item>
      </div>
      <div className="flex-1">
        <Form.Item label="Pulse (bpm)" name="pulse" className="!mb-0">
          <Input className="form-input" />
        </Form.Item>
      </div>
      <div className="flex-1">
        <Form.Item label="Oximetry (%)" name="oximetry" className="!mb-0">
          <Input className="form-input" />
        </Form.Item>
      </div>
      <div className="flex-1">
        <Form.Item label="Weight (kg)" name="weight" className="!mb-0">
          <Input className="form-input" />
        </Form.Item>
      </div>
    </div>
  );
};

export default VitalSignsSection;
